<div class="set-password" appMargin>
  <img src="./assets/images/logo.png" class="logo" alt="SiteSoft New Zealand Ltd" />
  <mat-card appearance="outlined">
    <mat-card-content>
      <h1 class="h5 mb-3">Set Your Password</h1>

      @if (state === 'validating') {
        <p class="text-muted mb-0">Checking your link...</p>
      }

      @if (state === 'invalid') {
        <div class="alert alert-warning text-left" role="alert">
          {{ invalidMessage }}
        </div>
        <button type="button" mat-raised-button color="primary" routerLink="/sign-in" appMarginTop class="full-width">
          Sign In
        </button>
        @if (canResetPassword) {
          <button type="button" mat-button routerLink="/forgot-password" appMarginTop class="full-width">
            Forgot Password
          </button>
        }
      }

      @if (state === 'form') {
        <form (submit)="onSetPassword(f)" #f="ngForm">
          <p>
            <mat-hint>
              Choose a password for your {{ utils.getAppName() }} account. This also confirms your email address.
            </mat-hint>
          </p>

          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>New Password</mat-label>
            <input
              matInput
              placeholder="New Password"
              required
              [(ngModel)]="password"
              name="password"
              autocomplete="new-password"
              [type]="passwordFieldType"/>
            <button mat-icon-button matSuffix aria-label="Show/Hide" (click)="togglePasswordVisibility('password')" type="button">
              <mat-icon>{{ passwordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-hint>Enter a new password for your account.</mat-hint>
          </mat-form-field>

          <app-password-strength-indicator [passwordInput]="password" (passwordValidatedOutput)="getOutputPasswordValidated($event)"></app-password-strength-indicator>

          <mat-form-field class="full-width my-3" appearance="outline" subscriptSizing="dynamic">
            <mat-label>New Password Confirmation</mat-label>
            <input
              matInput
              placeholder="New Password Confirmation"
              required
              [(ngModel)]="passwordConfirmation"
              name="passwordConfirmation"
              autocomplete="new-password"
              [type]="confirmPasswordFieldType"/>
            <button mat-icon-button matSuffix aria-label="Show/Hide" (click)="togglePasswordVisibility('confirmPassword')" type="button">
              <mat-icon>{{ confirmPasswordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <mat-hint>Enter the new password again for confirmation.</mat-hint>
          </mat-form-field>

          <button mat-raised-button color="primary" type="submit" [disabled]="inProgress || !f.valid || password !== passwordConfirmation || !passwordValidated" appMarginTop class="full-width">
            Save Password
          </button>
          <button type="button" mat-button routerLink="/sign-in" appMarginTop class="full-width">
            Sign In
          </button>
        </form>
      }
    </mat-card-content>
  </mat-card>
</div>
